/* @flow */

import VanillaToasts from 'vanillatoasts';
import MENSAGENS from '../mensagens';

const obrigatorio = () => { throw new TypeError(); };

const notificarErro = (err: Object) => {
    const { status, data } = err.response;
    VanillaToasts.create({
        title: MENSAGENS.UTILS.EXIBIR_ERRO.TITULO,
        text: status < 500 ? data.mensagem || data.message : '',
        type: 'danger',
        timeout: 8000,
    });
};

export {
    obrigatorio,
    notificarErro,
};
